<template>
  <div>
    <div class="title text-center">
      <div class="container lg">
        <span class="text-accent">Referral</span>
        <div class="left">
          <a v-on:click="$router.go(-1)">
            <i class="fad fa-arrow-left fa-back"></i
          ></a>
        </div>
      </div>
    </div>

    <div class="container-center lg">
      <referral></referral>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import referral from "@/components/referral";

export default {
  components: {
    referral
  },
  computed: mapGetters(["getCurrency"])
};
</script>

<style scope>
.fa-3x {
  width: 50px;
}
</style>
